export const ChangeRouting = [
  {
    path: "/quality/change/list",
    name: "quality-change-list",
    meta: { title: "质量整改单" },
    component: () =>
      import(/* webpackChunkName: "quality-change" */ "@/views/quality/change/list/index.vue"),
  },
  {
    hidden: true,
    path: "/quality/change/create",
    name: "quality-change-create",
    meta: { title: "新增质量整改单", comName: "QualityChangeFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "quality-change" */ "@/views/quality/change/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/quality/change/edit/:id",
    name: "quality-change-edit",
    meta: { title: "编辑质量整改单", comName: "QualityChangeFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "quality-change" */ "@/views/quality/change/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/quality/change/flowPrint/:id",
    name: "quality-change-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "quality-change" */ "@/views/quality/change/form-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/quality/change/detail/:id",
    name: "quality-change-detail",
    meta: { title: "质量整改单详情" },
    component: () =>
      import(
        /* webpackChunkName: "quality-change" */ "@/views/quality/change/form-detail/index.vue"
      ),
  },
];
